import {
  findRouteByName,
  Menu,
} from '@/internal';

export default () => {
  return new Menu({
    menuItems: [
      {
        title: 'Projects',
        route: findRouteByName('projects'),
        icon: 'calendar',
        iconPack: 'fal',
        menuItems: [
          {
            route: {
              ...findRouteByName('projects/current'),
              params: {
              },
            },
            title: 'Current Projects',
            icon: 'calendar-clock',
            iconPack: 'fal',
            activeWithParent: true,
          },
          {
            route: {
              ...findRouteByName('projects/past'),
              params: {
              },
            },
            title: 'Past Projects',
            icon: 'calendar-check',
            iconPack: 'fal',
          },
        ],
      },
    ],
  });
};
